if ( typeof CartForm !== 'function' ) {
	class CartForm extends HTMLElement {

		constructor(){
			super();
			this.ajaxifyCartItems();
		}

		ajaxifyCartItems(){

			this.form = this.querySelector('form');

			// Check and adjust existing quantities on initialization
			this.adjustExistingQuantities();

			this.querySelectorAll('[data-js-cart-item]').forEach(item=>{

				const remove = item.querySelector('.remove');
				if ( remove ) {
					remove.dataset.href = remove.getAttribute('href');
					remove.setAttribute('href', '');
					remove.addEventListener('click', (e)=>{
						e.preventDefault();
						this.updateCartQty(item, 0);
					})
				}

				const qty = item.querySelector('.qty');
				if ( qty ) {
					qty.addEventListener('input', debounce(e=>{
				e.preventDefault();
				e.target.blur();
				const newQty = parseInt(qty.value);
				// Validate before updating
				if (window.validateCartItemQuantity(item, newQty)) {
					this.updateCartQty(item, newQty);
				} else {
					// Reset to previous valid value or minimum valid value
					const qtyRule = item.querySelector('.qty-rule');
					if (qtyRule && qtyRule.hasAttribute('data-multiple')) {
						const multiple = parseInt(qtyRule.getAttribute('data-multiple'));
						const validQty = Math.ceil(newQty / multiple) * multiple;
						qty.value = validQty;
						this.updateCartQty(item, validQty);
					}
				}
			}, 500));
					qty.addEventListener('click', (e)=>{
						e.target.select();
					})
				}

			})

		}

		adjustExistingQuantities(){
			this.querySelectorAll('[data-js-cart-item]').forEach(item=>{
				const qtyInput = item.querySelector('.qty');
				const qtyRule = item.querySelector('.qty-rule');
				
				if (qtyInput && qtyRule && qtyRule.hasAttribute('data-multiple')) {
					const currentQty = parseInt(qtyInput.value);
					const multiple = parseInt(qtyRule.getAttribute('data-multiple'));
					
					if (multiple > 0 && currentQty % multiple !== 0) {
						const adjustedQty = Math.ceil(currentQty / multiple) * multiple;
						this.updateCartQty(item, adjustedQty);
					}
				}
			});
		}

		updateCartQty(item, newQtyCart){

			let alert = null;

			// Adjust quantity to match data-multiple attribute if needed
			const qtyRule = item.querySelector('.qty-rule');
			if (qtyRule && qtyRule.hasAttribute('data-multiple')) {
				const multiple = parseInt(qtyRule.getAttribute('data-multiple'));
				if (multiple > 0 && newQtyCart % multiple !== 0) {
					// Adjust to nearest valid multiple (round up to ensure divisibility)
					newQtyCart = Math.ceil(newQtyCart / multiple) * multiple;
				}
			}

			this.form.classList.add('processing');
			if ( this.querySelector('.alert') ) {
				this.querySelector('.alert').remove();
			}

			const body = JSON.stringify({
				line: parseInt(item.dataset.line),
				quantity: newQtyCart
			});

			fetch(KROWN.settings.routes.cart_change_url, {
					method: 'POST',
					headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
					body
				})
				.then(response => response.json())
				.then(response => {
					if ( response.status == 422 ) {
						// wrong stock logic alert
						alert = document.createElement('span');
						alert.classList.add('alert', 'alert--error');
						if ( typeof response.description === 'string' ) {
							alert.innerHTML = response.description;
						} else {
							alert.innerHTML = response.message;
						}
					}
					// Refresh the cart after successful update
					window.refreshCart();
				})
				.catch(e => {
					console.log(e);
					let alert = document.createElement('span');
					alert.classList.add('alert', 'alert--error');
					alert.textContent = KROWN.settings.locales.cart_general_error;
					this.form.prepend(alert);
				})
				.finally(() => {
					this.form.classList.remove('processing');
				});
		}

	} 


  if ( typeof customElements.get('cart-form') == 'undefined' ) {
		customElements.define('cart-form', CartForm);
	}

}

// The theme's native code
if ( typeof CartProductQuantity !== 'function' ) {

	class CartProductQuantity extends HTMLElement {
		constructor(){
			super();
			this.querySelector('.qty-minus').addEventListener('click', this.changeCartInput.bind(this));
			this.querySelector('.qty-plus').addEventListener('click', this.changeCartInput.bind(this));
			// this.querySelector('.qty-rule').addEventListener('input', this.changeCartInput.bind(this));
			// this.querySelector('.qty-rule').addEventListener('change', this.changeCartInput.bind(this));
		}
		changeCartInput(){
			setTimeout(()=>{
				const item = this.closest('[data-js-cart-item]');
				const newQty = parseInt(this.querySelector('.qty').value);
				// Validate before updating
				if (window.validateCartItemQuantity(item, newQty)) {
					document.getElementById('AjaxCartForm').updateCartQty(item, newQty);
				} else {
					// Reset to previous valid value or adjust to nearest valid value
					const qtyRule = item.querySelector('.qty-rule');
					if (qtyRule && qtyRule.hasAttribute('data-multiple')) {
						const multiple = parseInt(qtyRule.getAttribute('data-multiple'));
						const validQty = Math.ceil(newQty / multiple) * multiple;
						this.querySelector('.qty').value = validQty;
						document.getElementById('AjaxCartForm').updateCartQty(item, validQty);
					}
				}
			}, 50);
		}
	}

  if ( typeof customElements.get('cart-product-quantity') == 'undefined' ) {
		customElements.define('cart-product-quantity', CartProductQuantity);
	}

}

// if (typeof CartProductQuantity !== 'function') {

//   class CartProductQuantity extends HTMLElement {
//     constructor() {
//       super();

//       // Scope selectors to the cart-product-quantity element
//       this.qty = this.querySelector('.qty'); // No need for 'cart-product-quantity .qty'
//       this.qtyMinus = this.querySelector('.qty-minus');
//       this.qtyPlus = this.querySelector('.qty-plus');

//       console.log('qtyCart', this.qty);

//       // Parse attributes
//       this.qtyMin = this.qty.hasAttribute('min') ? parseInt(this.qty.getAttribute('min')) : 0; 
//       this.qtyMax = this.qty.hasAttribute('max') ? parseInt(this.qty.getAttribute('max')) : 999;
//       this.qtyMultiple = this.qty.dataset.multiple ? parseInt(this.qty.dataset.multiple) : 1; // Default to 1, not 0

//       console.log('min', this.qtyMin);
//       console.log('max', this.qtyMax);
//       console.log('multiple', this.qtyMultiple);
//       console.log('divider-----------------------------------------------------');

//       // Initialize button states
//       this.updateButtonStates();

//       // Add event listeners
//       this.qtyMinus.addEventListener('click', this.handleMinusClick.bind(this));
//       this.qtyPlus.addEventListener('click', this.handlePlusClick.bind(this));
//     }

//     // Handle minus button click
//     handleMinusClick(e) {
//       e.preventDefault();
//       const currentQty = parseInt(this.qty.value);
//       let newQtyCart = currentQty - this.qtyMultiple;

//       // If min is 0, allow decreasing to 0
//       if (this.qtyMin === 0 && newQtyCart < 0) {
//         newQtyCart = 0;
//       }

//       // Ensure newQtyCart is not below the minimum
//       if (newQtyCart >= this.qtyMin) {
//         this.qty.value = newQtyCart;
//         this.updateButtonStates();
//         this.updateCartQty(newQtyCart);
//       }
//     }

//     // Handle plus button click
//     handlePlusClick(e) {
//       e.preventDefault();
//       const currentQty = parseInt(this.qty.value);
//       const newQtyCart = currentQty + this.qtyMultiple;

//       // Ensure newQtyCart is not above the maximum
//       if (newQtyCart <= this.qtyMax) {
//         this.qty.value = newQtyCart;
//         this.updateButtonStates();
//         this.updateCartQty(newQtyCart);
//       }
//     }

//     // Update button disabled states
//     updateButtonStates() {
//       const currentQty = parseInt(this.qty.value);

//       if (currentQty <= this.qtyMin) {
//         this.qtyMinus.classList.add('disabled');
//       } else {
//         this.qtyMinus.classList.remove('disabled');
//       }

//       if (currentQty >= this.qtyMax) {
//         this.qtyPlus.classList.add('disabled');
//       } else {
//         this.qtyPlus.classList.remove('disabled');
//       }
//     }

//     // Update cart quantity via AJAX
//     updateCartQty(newQtyCart) {
//       setTimeout(() => {
//         document.getElementById('AjaxCartForm').updateCartQty(
//           this.closest('[data-js-cart-item]'),
//           newQtyCart
//         );
//       }, 50);
//     }
//   }

//   if (typeof customElements.get('cart-product-quantity') == 'undefined') {
//     customElements.define('cart-product-quantity', CartProductQuantity);
//   }
// }


// method for apps to tap into and refresh the cart

// Function to check if quantity is valid based on data-multiple attribute
if ( ! window.validateCartItemQuantity ) {
	window.validateCartItemQuantity = (item, quantity) => {
		const qtyRule = item.querySelector('.qty-rule');
		if (qtyRule && qtyRule.hasAttribute('data-multiple')) {
			const multiple = parseInt(qtyRule.getAttribute('data-multiple'));
			if (multiple > 0) {
				return quantity % multiple === 0;
			}
		}
		return true; // If no data-multiple attribute, quantity is always valid
	};
}

if ( ! window.refreshCart ) {

	window.refreshCart = () => {
		
		fetch('?section_id=helper-cart')
			.then(response => response.text())
			.then(text => {

			const sectionInnerHTML = new DOMParser().parseFromString(text, 'text/html');
			const cartFormInnerHTML = sectionInnerHTML.getElementById('AjaxCartForm').innerHTML;
			const cartSubtotalInnerHTML = sectionInnerHTML.getElementById('AjaxCartSubtotal').innerHTML;

			const cartItems = document.getElementById('AjaxCartForm');
			cartItems.innerHTML = cartFormInnerHTML;
			cartItems.ajaxifyCartItems();

			// Re-attach close button event listener
			const sidebar = document.getElementById('site-cart-sidebar');
			const closeButton = sidebar.querySelector('[data-js-close]');
			if (closeButton) {
				// Remove any existing listeners to avoid duplicates
				closeButton.replaceWith(closeButton.cloneNode(true));
				const newCloseButton = sidebar.querySelector('[data-js-close]');
				newCloseButton.addEventListener('click', () => {
					sidebar.hide();
				});
			}

			document.querySelectorAll('[data-header-cart-count]').forEach(elm=>{
				elm.textContent = cartItems.querySelector('[data-cart-count]').textContent;
			});
			document.querySelectorAll('[data-header-cart-total').forEach(elm=>{
				elm.textContent = cartItems.querySelector('[data-cart-total]').textContent;
			})
			
			document.getElementById('AjaxCartSubtotal').innerHTML = cartSubtotalInnerHTML;
			if ( document.querySelector('[data-js-site-cart-sidebar]') ) {
				document.querySelector('[data-js-site-cart-sidebar]').show();
			}

			if ( document.querySelector('cart-recommendations') ) {
				document.querySelector('cart-recommendations').innerHTML = '';
				document.querySelector('cart-recommendations').generateRecommendations();
			}

		})

	}

}

if ( ! customElements.get('cart-note') ) {
  customElements.define(
    'cart-note',
    class CartNote extends HTMLElement {
      constructor() {
        super();
        this.addEventListener(
          'input',
          debounce(event => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${KROWN.settings.routes.cart_update_url}`, { 
							method: 'POST',
							headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
							body 
						});
		  		}, 150)
				);
      }
    }
  );
}